import React from 'react';
import { Section } from './Section';
import { audiences } from '../data/content';
export function Audiences() {
  return <Section title="¿Quién debería comprar esto?" data-id="element-1" data-mp="33hznl8x6ii5q">
      <dl className="divide-y divide-ink-line border-y border-ink-line" data-id="element-2" data-mp="2om1u5yen3rx7">
        {audiences.map(audience => <div key={audience.role} className="grid grid-cols-1 gap-1 py-6 md:grid-cols-12 md:gap-8" data-id="element-3" data-mp="2tklig5gphfsq">
            <dt className="text-lg font-semibold text-ink md:col-span-4" data-id="element-4" data-mp="2fsyc1ct1uqw8">{audience.role}</dt>
            <dd className="text-lg leading-relaxed text-ink-soft md:col-span-8" data-id="element-5" data-mp="2kl88lboo6p7h">
              {audience.benefit}
            </dd>
          </div>)}
      </dl>
    </Section>;
}